// frontend/src/pages/LoginPage.js
import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Button,
  Box,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import { toast } from "react-toastify";
import PageContainer from "./PageContainer";

function LoginPage() {
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Redirect if already authenticated
  useEffect(() => {
    if (userInfo) {
      navigate("/home");
    }
  }, [userInfo, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const loginResponse = await axios.post(
        "/api/auth/login",
        { email, password },
        { withCredentials: true }
      );

      // Use the user data directly from the login response
      setUserInfo(loginResponse.data.user);
      navigate("/");
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid credentials");
    }
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        height="100vh"
      >
        <Box
          flex={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="background.paper"
          padding={{ xs: 2, md: 0 }}
        >
          <Box width={{ xs: "90%", sm: "80%", md: "60%" }}>
            <img
              style={{ marginBottom: "2rem", maxWidth: "100%", height: "auto" }}
              src="https://xsmbasketball.com/wp-content/uploads/thegem-logos/logo_033fe9e10695d37313702194ad3be9ed_2x.png"
              alt="Login logo"
            />
            <Typography variant="h4" align="center" gutterBottom>
              Login
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email Address"
                placeholder="you@example.com"
                margin="normal"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                fullWidth
                type="password"
                label="Password"
                placeholder="Enter 6 characters or more"
                margin="normal"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
              >
                LOGIN
              </Button>
              <Box mt={2} textAlign="center">
                <Typography variant="body2">
                  Don't have an account?{" "}
                  <MuiLink component={Link} to="/signup">
                    Sign up here
                  </MuiLink>
                </Typography>
              </Box>
            </form>
          </Box>
        </Box>
        <Box
          sx={{ textAlign: "center", alignContent: "center" }}
          flex={1}
          bgcolor="primary.main"
          display={{ xs: "none", md: "block" }}
        >
          <img
            src="https://xsmbasketball.com/wp-content/uploads/2023/05/XSM-Box-Scores.png"
            alt="Login Illustration"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Box>
      </Box>
    </>
  );
}

export default LoginPage;
